import { useMutation, type MutationHookOptions } from "@apollo/client"
import mutation from "@/v2-backoffice-client/invitation/remove/many/invitation.remove.many.mutation.gql"
import type {
  InvitationRemoveManyMutation,
  InvitationRemoveManyMutationVariables,
} from "@/v2-backoffice-client/invitation/remove/many/__types__/invitation.remove.many.mutation"

type Options = MutationHookOptions<
  InvitationRemoveManyMutation,
  InvitationRemoveManyMutationVariables
>

export function useInvitationRemoveManyMutation(options?: Options) {
  return useMutation<
    InvitationRemoveManyMutation,
    InvitationRemoveManyMutationVariables
  >(mutation, options)
}
